import React, { useEffect } from "react";
import CustomSelectDropdown from "../../../../components/CustomSelectDropDown";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";

function ComplianceYear({name}) {
  const [year, setYear] = useCustomSearchParams("year");
  const currentYear = new Date().getFullYear();
  const startYear = 2017;
  const endYear = currentYear + 1;
  const lastFiveYears = [];

  for (let y = startYear; y <= endYear; y++) {
    lastFiveYears.push({ label: y, value: y });
  }
  lastFiveYears.reverse();
  useEffect(() => {
    setYear("year", year || currentYear);
  }, []);

  return (
    <div className="d-flex align-items-center mr-2">
      <p className="compliance-year-txt mr-2">{name}</p>
      <div className="">
        <CustomSelectDropdown
          defaultValue={year || currentYear}
          options={lastFiveYears}
          label={""}
          onSelectChange={(value) => {
            setYear("year", value);
          }}
        />
      </div>
    </div>
  );
}

export default ComplianceYear;
